import { useNavigate } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";

export function MobileHeader({ title, subtitle, onBack, rightSlot }) {
  const navigate = useNavigate();
  return (
    <header
      className="sticky top-0 z-30 safe-top border-b border-[#E7E5E4] bg-white/70 backdrop-blur-xl px-4 pt-3 pb-2.5"
      data-testid="mobile-header"
    >
      <div className="flex items-center gap-3">
        {onBack && (
          <button
            onClick={() => (onBack === true ? navigate(-1) : onBack())}
            data-testid="mobile-header-back-button"
            aria-label="Back"
            className="press-scale w-9 h-9 rounded-full bg-[#E7E5E4]/70 flex items-center justify-center flex-shrink-0 text-[#1C1917] transition-colors duration-200"
          >
            <CaretLeft size={18} weight="bold" />
          </button>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="font-display text-xl leading-tight text-[#1C1917] truncate">{title}</h1>
          {subtitle && <p className="text-xs text-[#78716C] mt-0.5 truncate">{subtitle}</p>}
        </div>
        {rightSlot}
      </div>
    </header>
  );
}
